// Tiny count-based singular/plural helper for notification copy. Not full
// i18n - just resolves "1 agent" vs "2 agents" so callers stop hand-rolling
// ternaries per string. Kept in sync with Gitcha-API's
// src/helpers/grammar.helper.js - same rule, same parseInt coercion.
export const pluralize = (count, singular, plural = `${singular}s`) => {
  const n = parseInt(count, 10) || 0;
  return n === 1 ? singular : plural;
};

// Same rule, opposite-feeling argument order: a singular SUBJECT ("1 agent")
// takes the singular-looking VERB ("has"/"matches"), so the verb form that
// reads first here is the one that pairs with count === 1. Named separately
// from pluralize() so `pluralizeVerb(count, "has", "have")` doesn't look
// backwards at the call site.
export const pluralizeVerb = (count, singularVerb, pluralVerb) =>
  pluralize(count, singularVerb, pluralVerb);
